import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import CustomFieldsSettings from './CustomFieldsSettings.jsx';

const CustomFieldsSettingsIndex = () => {
    return (
        <div>
            <div className="mb-4">
                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                    <div>
                        <h1 className="h2 fw-bold text-dark d-flex align-items-center gap-2 mb-2">
                            <SlidersHorizontal size={32} className="icon-settings" />
                            Zusatzfelder
                        </h1>
                        <p className="text-muted mb-0">
                            Definiere benutzerdefinierte Felder für Kontakte, Jobs und Hochzeiten.
                        </p>
                    </div>
                </div>
            </div>
            <CustomFieldsSettings />
        </div>
    );
};

export default CustomFieldsSettingsIndex;
